module.exports = __webpack_public_path__ + "static/media/40-1.75dc1e32.mp3";